import { useFormik } from "formik";

export function BlogForm(submit, initialVal, cb, checkBlogData) {
  const validation = (values) => {
  function hasWhiteSpace(s) {
    return (/\s/).test(s);
  }
    let errors = {};
    let blogError = false;
    if (!values.title) {
      errors.title = "Blog title is required";
      blogError = true;
    }

    if (values.title?.trim() === "") {
      errors.title = "Blog title is required";
      blogError = true;
    }

    if (!values.slug) {
      errors.slug = "Slug is required";
      blogError = true;
    }

    if (values.slug?.trim() === "") {
      errors.slug = "Slug is required";
      blogError = true;
    }

    if (!values.description) {
      errors.description = "Description is required";
      blogError = true;
    }

    if(hasWhiteSpace(values.url_category_slug) == true) {
        errors.url_category_slug = "Incorrect Category Slug";
        blogError = true;
    }
    checkBlogData(blogError);
    if (cb) {
      cb(values);
    }
    return errors;
  };

  const initialValues = {
    title: "",
    detail: "",
    slug: "",
    description: "",
    keywords: "",
    author_name: "",
    read_time: "",
    blog_date: "",
    url_category_slug:"",
  };

  const formik = useFormik({
    initialValues: initialVal || initialValues,
    onSubmit: submit,
    enableReinitialize: true,
    validate: validation,
  });

  return { formik };
}
